// Offset #fragment target anchor position by height of alertbanner, if any

if (window.location.hash) {
    document.body.onload = function() {
        function offset(el) {
            var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }
        const banner = document.getElementById('alertbanner');
        const bannerHeight = banner.getBoundingClientRect().height;
        const anchor = document.getElementById(window.location.hash.substring(1));
        if (anchor) {
            const anchorLocation = offset(anchor).top - bannerHeight;
            function correctScroll () {
                window.scroll(0, anchorLocation);
            }
            requestAnimationFrame(correctScroll);
        }
    }
}
